export default {
  watchErrorGeneric:
    "We're currently experiencing difficulties playing this title. Kindly attempt playback later or choose an alternative title",
  watchErrorGeoBlock:
    "The content you are looking for is not available in your region. Don't worry, there's plenty more to explore. Check out our platform for the latest and exciting content.",
};
